import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { useRoute } from 'vue-router';
import { controlDeferred } from '@eureka/utils/control';

export const useGlobalState = createGlobalState(() => {
    const route = useRoute();
    // state
    const checkedChild = ref<boolean>(false);
    const companyId = ref<string>((route.query.id as string) || '');
    const isLimitedChecked = ref<boolean>(false);
    const isFreemium = ref<boolean>(false);

    function updateCheckedChild() {
        checkedChild.value = !checkedChild.value;
    }

    function updateLimitInfo(value: boolean) {
        if (value) {
            isLimitedChecked.value = value;
        }
    }

    controlDeferred.promise.then(({ freemium }) => {
        isFreemium.value = freemium;
    });

    return {
        companyId,
        checkedChild,
        isLimitedChecked,
        isFreemium,
        updateCheckedChild,
        updateLimitInfo,
    };
});
